const GET_ORDER_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors du chargement des paramètres des commandes.";
const UPDATE_ORDER_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors de l'enregistrement des paramètres des commandes.";
export const GET_ORDER_SETTINGS_ERROR = GET_ORDER_SETTINGS_ERROR_TEXT;
export const UPDATE_ORDER_SETTINGS_ERROR = UPDATE_ORDER_SETTINGS_ERROR_TEXT;


const GET_ORDER_SHIFTS_ERROR_TEXT = "Une erreur est survenue lors du chargement des horaires des commandes.";
const ADD_ORDER_SHIFT_ERROR_TEXT = "Une erreur est survenue lors de l'ajout de l'horaire de commande.";
const DELETE_ORDER_SHIFT_ERROR_TEXT = "Une erreur est survenue lors de la suppression de l'horaire de commande.";
const UPDATE_ORDER_SHIFT_ERROR_TEXT = "Une erreur est survenue lors de la modification de l'horaire de commande.";
export const GET_ORDER_SHIFTS_ERROR = GET_ORDER_SHIFTS_ERROR_TEXT;
export const ADD_ORDER_SHIFT_ERROR = ADD_ORDER_SHIFT_ERROR_TEXT;
export const DELETE_ORDER_SHIFT_ERROR = DELETE_ORDER_SHIFT_ERROR_TEXT;
export const UPDATE_ORDER_SHIFT_ERROR = UPDATE_ORDER_SHIFT_ERROR_TEXT;


const GET_ORDER_PRODUCTS_ERROR_TEXT = "Une erreur est survenue lors du chargement des produits.";
const ADD_ORDER_PRODUCT_ERROR_TEXT = "Une erreur est survenue lors de l'ajout du produit.";
const DELETE_ORDER_PRODUCT_ERROR_TEXT = "Une erreur est survenue lors de la suppression du produit.";
const UPDATE_ORDER_PRODUCT_ERROR_TEXT = "Une erreur est survenue lors de la modification du produit.";
export const GET_ORDER_PRODUCTS_ERROR = GET_ORDER_PRODUCTS_ERROR_TEXT;
export const ADD_ORDER_PRODUCT_ERROR = ADD_ORDER_PRODUCT_ERROR_TEXT;
export const DELETE_ORDER_PRODUCT_ERROR = DELETE_ORDER_PRODUCT_ERROR_TEXT;
export const UPDATE_ORDER_PRODUCT_ERROR = UPDATE_ORDER_PRODUCT_ERROR_TEXT;


const GET_ORDERS_ERROR_TEXT = "Une erreur est survenue lors du chargement des commandes.";
const UPDATE_ORDER_ERROR_TEXT = "Une erreur est survenue lors de la modification des commandes.";
export const GET_ORDERS_ERROR = GET_ORDERS_ERROR_TEXT;
export const UPDATE_ORDER_ERROR = UPDATE_ORDER_ERROR_TEXT;

const GET_NEW_ORDERS_ERROR_TEXT = "Une erreur est survenue lors du chargement des commandes à venir.";
export const GET_NEW_ORDERS_ERROR = GET_NEW_ORDERS_ERROR_TEXT;

const ACTIVATE_STRIPE_ERROR_TEXT = "Une erreur est survenue lors de la connexion de Stripe.";
export const ACTIVATE_STRIPE_ERROR = ACTIVATE_STRIPE_ERROR_TEXT;

const DEACTIVATE_STRIPE_ERROR_TEXT = "Une erreur est survenue lors de la déconnexion de Stripe.";
export const DEACTIVATE_STRIPE_ERROR = DEACTIVATE_STRIPE_ERROR_TEXT;


// WEBPACK FOOTER //
// ./src/errors/orders.js